import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
    padding: 8rem 2rem;
`;

export const Header = styled.div`
    max-width: 760px;
    margin: 0 auto 5rem;
    text-align: center;
`;

export const Badge = styled.span`
    display: inline-block;

    padding: .5rem 1rem;
    margin-bottom: 1.5rem;

    border-radius: 999px;

    background: rgba(127, 191, 208, .12);
    border: 1px solid rgba(127, 191, 208, .25);

    color: ${({ theme }) => theme.colors.primary};

    font-size: .9rem;
    font-weight: 600;
`;

export const Title = styled.h2`
    color: ${({ theme }) => theme.colors.white};

    font-size: clamp(2rem, 5vw, 3rem);

    font-weight: 700;

    line-height: 1.2;

    margin-bottom: 1.5rem;
`;

export const Description = styled.p`
    color: ${({ theme }) => theme.colors.gray};

    font-size: 1.05rem;

    line-height: 1.8;
`;

export const Grid = styled.div`
    width: 100%;
    max-width: 1400px;

    margin: 0 auto;

    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    gap: 2rem;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
    }
`;